import React, {useState} from "react";
import {Link} from "react-router-dom";
import BadgeCounter from "../BadgeCounter";

import './VerticalNavigationBarItem.css'

const VerticalNavigationBarItem = ({link, disabled, badgeNumber, onClick}) => {
    const [isOpen, setIsOpen] = useState(false);
    const {route, label, redirect, subItems} = link;
    
    const hasSubItems = !!(subItems && subItems.length > 0);
    const showExpandedLabel = label.length > 32;

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    const getClassList = () => {
        const classes = ["vertical-nav-item"];

        if (hasSubItems) {
            classes.push("has-children");

            if (isOpen) {
                classes.push("active-child")
                classes.push("active")
            }
        }

        if (disabled) {
            classes.push("disabled");
        }

        return classes.join(" ");
    }
    
    const getLinkClassList = () => {
        return showExpandedLabel ? 'expanded-title' : '';
    };
    return (
        <li className={getClassList()}>
            {/* Main menu alternative with path directly */}
            {route &&
                <Link to={route} target={redirect ? '_blank' : null} className={getLinkClassList()}>{label}<BadgeCounter badgeNumber={badgeNumber}/></Link>
            }

            {!hasSubItems && onClick &&
                <a onClick={onClick} className={getLinkClassList()}>{label}<BadgeCounter badgeNumber={badgeNumber}/></a>
            }

            {/*Main menu alternative with subitems*/}
            {hasSubItems && <a onClick={toggleMenu} className={getLinkClassList()}>{label}<BadgeCounter badgeNumber={subItems?.reduce((sum, subItem) => sum + (subItem.badgeNumber || 0), 0)}/></a>}

            {subItems &&
                <ul className="nav" aria-hidden={false} aria-expanded={true} aria-controls="subMenu">
                    {subItems.filter(link => !link.hidden).map((subItem, index) => {
                        return <VerticalNavigationBarItem key={index} link={subItem.link} disabled={subItem.disabled}
                                                          badgeNumber={subItem.badgeNumber} onClick={subItem.onClick}/>
                    })}
                </ul>
            }
        </li>
    );
}

export default VerticalNavigationBarItem;